"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_TOAST = exports.REMOVE_ALL = exports.CONFIG_UPDATE = exports.ADD_TOAST = void 0;
var ADD_TOAST = 'Toaster:add';
exports.ADD_TOAST = ADD_TOAST;
var REMOVE_TOAST = 'Toaster:remove';
exports.REMOVE_TOAST = REMOVE_TOAST;
var REMOVE_ALL = 'Toaster:removeAll';
exports.REMOVE_ALL = REMOVE_ALL;
var CONFIG_UPDATE = 'Toaster:configUpdate';
exports.CONFIG_UPDATE = CONFIG_UPDATE;